module.exports = __webpack_public_path__ + "ty10-a436881c.png";